export const DEFAULT_SELECT_ALL_OPTION_VALUE = 'selectAll';
export const DEFAULT_SELECT_ALL_OPTION_LABEL = 'Select All';
export const DEFAULT_LIMIT_TAGS_VALUE = 2;
